import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Spinner, IconClose as BuiIconClose, Divider } from '@blocket/blocket-ui'
import { onEnterKeyEvent } from 'utils/events'

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const PreviewSlider = styled.div`
  margin: 0 20px;
  display: flex;
  overflow-x: auto;
`

const PreviewItem = styled.div`
  margin-right: 16px;
  margin-top: 16px;
  position: relative;
`

const PreviewImage = styled.div`
  background-image: ${({ src }) => `url(${src})`};
  background-size: cover;
  width: 72px;
  height: 72px;
  border-radius: 8px;
  cursor: pointer;
`

const SpinnerWrapper = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
`

const IconClose = styled(BuiIconClose)`
  position: absolute;
  top: -12px;
  right: -12px;
  width: 24px;
  height: 24px;
  background: #696766;
  border: 1px solid #fff;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
`

const PreviewImages = ({ previewImages, isUploading, removePreviewImage, onImageClick }) => {
  return (
    <ContentWrapper>
      <Divider />
      <PreviewSlider>
        {previewImages.map((image, i) => (
          <PreviewItem key={image.src}>
            <PreviewImage
              src={image.src}
              role="img"
              alt={image?.name}
              onClick={() => onImageClick({ activeIndex: i })}
            />
            {isUploading ? (
              <SpinnerWrapper>
                <Spinner white />
              </SpinnerWrapper>
            ) : (
              <IconClose
                tabIndex="0"
                aria-label={`Ta bort ${image?.name}.`}
                onClick={() => removePreviewImage(image.id)}
                onKeyDown={(e) => onEnterKeyEvent(e, () => removePreviewImage(image.id))}
              />
            )}
          </PreviewItem>
        ))}
      </PreviewSlider>
    </ContentWrapper>
  )
}

PreviewImages.propTypes = {
  previewImages: PropTypes.array.isRequired,
  isUploading: PropTypes.bool,
  removePreviewImage: PropTypes.func,
  onImageClick: PropTypes.func,
}

export default PreviewImages
